var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6H15M3 6C2.17157 6 1.5 5.32843 1.5 4.5C1.5 3.67157 2.17157 3 3 3H15C15.8284 3 16.5 3.67157 16.5 4.5C16.5 5.32843 15.8284 6 15 6M3 6L3 9C3 12.3137 5.68629 15 9 15C12.3137 15 15 12.3137 15 9V6M12.2343 8.48435H12.5155M12.2343 8.7656H12.5155M10.5 10.5C10.5 11.3284 9.82843 12 9 12C8.17157 12 7.5 11.3284 7.5 10.5C7.5 9.67157 8.17157 9 9 9C9.82843 9 10.5 9.67157 10.5 10.5ZM12.75 8.625C12.75 8.83211 12.5821 9 12.375 9C12.1679 9 12 8.83211 12 8.625C12 8.41789 12.1679 8.25 12.375 8.25C12.5821 8.25 12.75 8.41789 12.75 8.625Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.a4caaef864f5e2eaccc8ea5aacc705e3.svg";
export { ForwardRef as ReactComponent };